export const LOAD_FINANCIAL_DATA_SUMMARY_STARTED = "LOAD_FINANCIAL_DATA_SUMMARY_STARTED";
export const LOAD_FINANCIAL_DATA_SUMMARY_SUCCESS = "LOAD_FINANCIAL_DATA_SUMMARY_SUCCESS";
export const LOAD_FINANCIAL_DATA_SUMMARY_FAILED = "LOAD_FINANCIAL_DATA_SUMMARY_FAILED";
